import React from 'react';
import ContentLayout from 'components/ContentLayout/SmartLayout';
import MultipleMove from 'components/Sales/Smart/MoveMerge/MultipleMove';
import { getWarehouseCodeFromCache } from 'utils';
import { LS_DEFAULT_WAREHOUSE_KEY } from 'constants/config';

export default function SmartPickScreen(): JSX.Element {
  return (
    <ContentLayout
        titleKey="titles.multipleMove" value={getWarehouseCodeFromCache(Number(localStorage.getItem(LS_DEFAULT_WAREHOUSE_KEY)))}
     >
      <MultipleMove />
    </ContentLayout>
  );
}
